// 이제 안쓸지도???
import { useMenuToggleStore } from '../store/authStore';  


export const useMenu = () => {
  const { isMenuOpen, setIsMenuOpen } = useMenuToggleStore();

  const openMenu = () => {setIsMenuOpen(true)};
  const closeMenu = () => {setIsMenuOpen(false)};

  return {
    isMenuOpen,
    openMenu,
    closeMenu,
  };
};